/**
 * @module app.ext.mcg-informed
 */

import { autoinject } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import * as Mcg from 'app/ext/mcg-informed/interfaces';

@autoinject
export class QuestionResolver {

    public constructor(
        private readonly env: EnvironmentService,
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }

    public resolveQuestionViewModel(question: Mcg.Question): string | null {
        const questionType = question.inputType.toString();
        const view = this.env.getDynamicViewByKey('CCI.QuestionType', questionType);

        if(view) {
            this.logger.debug(`Resolving question type code [${questionType}] to '${view.title}' (${view.url}).`);
            return view.url;
        }

        this.logger.warn(`Did not resolve question type [${questionType}].`);
        return '';
    }

}
